var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"no-toolbar":""}},[_c('f7-navbar',{attrs:{"no-shadow":"","back-link":_vm.$t('global.navbar.back')}},[_c('f7-nav-title',[_vm._v(_vm._s(_vm.$t('modules.referral.title')))])],1),_c('ReferralSlot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }